class MulticolumnIconsSlider extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.multicolumnIconsSliderElement = this
    window.loadSwiper().then((Swiper) => {
      this.carousel = new Swiper(this.multicolumnIconsSliderElement, {
        direction: 'horizontal',
        autoplay: {
          delay: 3000,
          disableOnInteraction: true,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.3,
            centeredSlides: true,
            invisibleSlides: true,
            loop: true,
            spaceBetween: 16,
            startAt: 2,
          },
          768: {
            slidesPerView: 3,
            loop: false,
            centeredSlides: false,
            spaceBetween: 40,
          },
        },
      });

      window.addEventListener('resize', () => {
        this.carousel.update();
      });
    });
  }

  disconnectedCallback() {
    
  }
}

if (customElements.get('multicolumn-icons-slider') === undefined) {
  customElements.define('multicolumn-icons-slider', MulticolumnIconsSlider)
}